<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input type="text" class="form-control" v-model="cd" @keyup.enter="doFilter">
              <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Código</label>
            </div>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
              <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input type="text" class="form-control" v-model="unidadeCnpj" @keyup.enter="doFilter" placeholder="Informe um CNPJ válido" title="CNPJ da unidade, com ou sem máscara">
              <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Unidade</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input type="text" class="form-control" v-model="parceiroCnpj" @keyup.enter="doFilter" placeholder="Informe um CNPJ válido" title="CNPJ do parceiro, com ou sem máscara">
              <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Parceiro</label>
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0">
            <multiselect v-model="status"
                         :options="optionsLivStatus"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Status"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
            ></multiselect>
          </b-col>

          <b-col cols="2" class="p-a-0">
            <div class="input-group-btn">
              <div class="btn-group">
                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter">Filtrar</button>
                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter">Limpar</button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>


<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      cd: '',
      descr: '',
      unidadeCnpj: '',
      parceiroCnpj: '',
      status: [],
      optionsLivStatus: [],
      data_filter: []
    }
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    doFilter () {
      this.data_filter = {
        status: this.status,
        descr: this.descr,
        cd: this.cd,
        unidade_cnpj: this.unidadeCnpj,
        parceiro_cnpj: this.parceiroCnpj};
      this.$events.fire('filter-set', this.data_filter);
    },
    resetFilter () {
      this.cd = '';
      this.descr = '';
      this.unidadeCnpj = '';
      this.parceiroCnpj = '';
      this.status = '';
      this.$events.fire('filter-reset');
    },
    getStatus() {
      this.helpForm.params = { tabela: 'pessoa_parceira',
        coluna: 'status' };

      this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
      {
        new ReturnApi(response, this, true, false, false);
        response.items.forEach((obj)=>
        {
          this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
        });
      })
          .catch(errors =>
          {
            new ReturnApi(errors, this, true, false, false)
          });
    },
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
    },
  }
}
</script>
